export interface RanapFormMeta {
  elemId: string;
  label: string;
  category: string;
}

export const RANAP_RM_FORMS: RanapFormMeta[] = [
  // CPPT dan Asesmen
  { elemId: "tab-cppt", label: "CPPT", category: "CPPT dan Asesmen" },
  { elemId: "tab-anamnesis", label: "Anamnesis", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-awal", label: "Asesmen Awal Ranap Medis", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-awal-keperawatan", label: "Asesmen Awal Keperawatan Ranap Dewasa", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-kep-intensif", label: "Asesmen Awal Keperawatan Intensif", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-kemo", label: "Asesmen Pasien Kemoterapi", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-anak", label: "Asesmen Awal Keperawatan Anak", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-risjat", label: "Asesmen Risiko Jatuh (Morse)", category: "CPPT dan Asesmen" },
  { elemId: "tab-bundle-ppi", label: "Bundle PPI", category: "CPPT dan Asesmen" },
  { elemId: "tab-penggunaan-alat-reuse", label: "Penggunaan Alat Reuse", category: "CPPT dan Asesmen" },
  { elemId: "tab-pengkajian-restrain", label: "Pengkajian Restrain", category: "CPPT dan Asesmen" },
  { elemId: "tab-skrining-gizi-lanjut", label: "Skrining Gizi Lanjut", category: "CPPT dan Asesmen" },
  { elemId: "tab-skrining-bunuh-diri", label: "Skrining Risiko Bunuh Diri", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-populasi-khusus", label: "Asesmen Populasi Khusus", category: "CPPT dan Asesmen" },
  { elemId: "tab-asesmen-geriatri", label: "Asesmen Geriatri Komprehensif (CGA)", category: "CPPT dan Asesmen" },
  { elemId: "tab-catatan-edukasi", label: "Catatan Edukasi", category: "CPPT dan Asesmen" },
  { elemId: "tab-transfer-internal", label: "Transfer Internal", category: "CPPT dan Asesmen" },
  // Keperawatan dan Monitoring
  { elemId: "tab-tanda-vital", label: "Monitor TTV", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-grafik-ttv", label: "Grafik TTV Dewasa", category: "Keperawatan dan Monitoring" },
  // tab-ewss-anak, tab-observasi-kebidanan-bishop & tab-asesmen-bbl sengaja tidak diindeks:
  // ketiganya `visibility: false` di RekamMedisRanap (tidak pernah dirender), jadi
  // memunculkannya di pencarian hanya menghasilkan form yang tidak bisa dibuka.
  { elemId: "tab-askep", label: "Asuhan Keperawatan (SDKI/SLKI/SIKI)", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-catatan-pemberian-obat", label: "Catatan Pemberian Obat (CPO/MAR)", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-rekonsiliasi-obat", label: "Rekonsiliasi Obat", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-monitoring-transfusi", label: "Monitoring Transfusi", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-monitoring-gds", label: "Monitoring GDS", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-rekam-asuhan-hd", label: "Rekam Asuhan Pasien Hemodialisis", category: "Keperawatan dan Monitoring" },
  {
    elemId: "tab-pemantauan-terapi-gizi",
    label: "Pemantauan Terapi Gizi Terintegrasi",
    category: "Keperawatan dan Monitoring"
  },
  { elemId: "tab-nihss", label: "Penilaian NIHSS", category: "Keperawatan dan Monitoring" },
  // Skrining paliatif — dipisah per populasi (instrumen fungsional berbeda:
  // ECOG untuk dewasa, Skala Lansky untuk anak); tab difilter umur pasien.
  { elemId: "tab-skrining-paliatif-dewasa", label: "Skrining Paliatif Dewasa", category: "Keperawatan dan Monitoring" },
  { elemId: "tab-skrining-paliatif-anak", label: "Skrining Paliatif Anak", category: "Keperawatan dan Monitoring" },
  // Perioperatif
  { elemId: "tab-ceklist-invasif", label: "Ceklist Prosedur Invasif", category: "Perioperatif" },
  { elemId: "tab-asesmen-pra-sedasi", label: "Asesmen Pra Anestesi/Sedasi", category: "Perioperatif" },
  { elemId: "tab-checklist-anestesi", label: "Checklist Persiapan Anestesi", category: "Perioperatif" },
  { elemId: "tab-asesmen-pra-bedah", label: "Asesmen Pra Bedah", category: "Perioperatif" },
  { elemId: "tab-pra-sedasi", label: "Catatan Pra Anestesi/Sedasi", category: "Perioperatif" },
  { elemId: "tab-checklist-ok", label: "Checklist Keselamatan OK", category: "Perioperatif" },
  { elemId: "tab-pemantauan-anestesi", label: "Pemantauan Anestesi/Sedasi", category: "Perioperatif" },
  { elemId: "tab-monitoring-intra-op-lokal", label: "Monitoring Intra-Op Lokal", category: "Perioperatif" },
  { elemId: "tab-askeper-perioperatif", label: "Askep Perioperatif", category: "Perioperatif" },
  { elemId: "tab-laporan-operasi", label: "Laporan Operasi", category: "Perioperatif" },
  { elemId: "tab-catatan-paska-sedasi", label: "Catatan Paska Anestesi", category: "Perioperatif" },
  { elemId: "tab-pacu-rr", label: "PACU / RR", category: "Perioperatif" },
  // Kebidanan & BBL
  { elemId: "tab-asesmen-kebidanan", label: "Asesmen Awal Ranap Kebidanan", category: "Kebidanan & BBL" },
  { elemId: "tab-catatan-kebidanan", label: "Implementasi (Catatan Kebidanan)", category: "Kebidanan & BBL" },
  { elemId: "tab-observasi-kebidanan", label: "Observasi Kebidanan + Bishop", category: "Kebidanan & BBL" },
  { elemId: "tab-partograf", label: "Partograf", category: "Kebidanan & BBL" },
  { elemId: "tab-identitas-bayi", label: "Identitas Bayi Baru Lahir", category: "Kebidanan & BBL" },
  { elemId: "tab-asesmen-perinatal", label: "Asesmen Perinatal", category: "Kebidanan & BBL" },
  { elemId: "tab-catatan-harian-bbl", label: "Catatan Harian BBL", category: "Kebidanan & BBL" },
  { elemId: "tab-monitoring-harian-nicu", label: "Monitor Harian NICU", category: "Kebidanan & BBL" },
  // Clinical Pathway
  {
    elemId: "tab-cp",
    label: "Clinical Pathway (Sectio Caesarea, Partus Pervaginam, Preeklampsia, Hiperemesis, Abortus)",
    category: "Clinical Pathway"
  },
  // Intensif dan Kritis
  { elemId: "tab-icu-hcu", label: "ICU/NICU/HCU/ICCU", category: "Intensif dan Kritis" },
  { elemId: "tab-monitoring-trombolisis", label: "Monitoring Trombolisis", category: "Intensif dan Kritis" },
  { elemId: "tab-code-blue", label: "Pencatatan Code Blue", category: "Intensif dan Kritis" },
  { elemId: "tab-pengkajian-akhir-hayat", label: "Pengkajian Akhir Hayat", category: "Intensif dan Kritis" },
  // Resume dan MPP
  { elemId: "tab-resume-ranap", label: "Resume Ranap / Ringkasan Pulang", category: "Resume dan MPP" },
  { elemId: "tab-discharge-planning", label: "Discharge Planning (Perencanaan Pulang)", category: "Resume dan MPP" },
  { elemId: "tab-sebab-kematian", label: "Sebab Kematian", category: "Resume dan MPP" },
  { elemId: "tab-kepatuhan-visite", label: "Kepatuhan Visite DPJP", category: "Resume dan MPP" },
  { elemId: "tab-mpp", label: "MPP", category: "Resume dan MPP" },
  { elemId: "tab-berkas-rm", label: "Berkas Manual RM", category: "Resume dan MPP" }
];

/** One searchable entry in the universal form search on PasienFlyingBar. */
export interface FormIndexEntry {
  /** Human label shown + matched. */
  label: string;
  /** Top-tab v-model value in PemeriksaanRanap (e.g. "tab-rekam-medis"). */
  topTab: string;
  /** Group caption shown under the label (e.g. "Rekam Medis › CPPT dan Asesmen"). */
  group: string;
  /** Inner v-model value of the host sub-page (elemId / val / value). Omit for single-form hosts. */
  elemId?: string;
  /** For RekamMedisRanap only: category chip to activate before selecting the form. */
  category?: string;
  /** Third-level tab inside the host form (Ralan: CardSubAssesmen's inner tab). */
  subTab?: string;
  /** Extra terms to match on (synonyms, contents) besides label + group. */
  keywords?: string;
}

const PERSETUJUAN_FORMS: Array<[string, string, string?]> = [
  ["tab-general-consent", "General Consent"],
  ["tab-persetujuan-ranap", "Persetujuan Rawat Inap"],
  ["tab-penerimaan-pasien-baru-ranap", "Penerimaan Pasien Baru Ranap"],
  ["tab-persetujuan-intensif", "Persetujuan Rawat Intensif"],
  ["tab-dnr", "Persetujuan Tidak Dilakukan Resusitasi (DNR)"],
  ["tab-pemilihan-dokter", "Pernyataan Pemilihan Dokter"],
  ["tab-kronologi", "Pernyataan Kronologi"],
  ["tab-kenaikan-kelas", "Pernyataan Kenaikan Kelas"],
  ["tab-second-opinion", "Permintaan Second Opinion"],
  ["tab-informed-consent-tindakan", "Informed Consent Tindakan"],
  ["tab-persetujuan-anestesi", "Persetujuan Anestesi"],
  ["tab-persetujuan-laparotomi", "Persetujuan Laparotomi"],
  ["tab-persetujuan-marker-site", "Persetujuan/Penolakan Marker Site"],
  ["tab-persetujuan-reuse", "Persetujuan Alat Re-Use"],
  ["tab-persetujuan-obat", "Persetujuan Penggunaan Obat"],
  [
    "tab-persetujuan-transfusi-darah",
    "Persetujuan Layanan Darah",
    "transfusi darah inkompatibel incompatible crossmatch plebotomi flebotomi phlebotomy informed consent bank darah"
  ],
  ["tab-persetujuan-kb", "Persetujuan KB"],
  ["tab-pulang-aps", "Pulang Atas Permintaan Sendiri (APS)"],
  ["tab-permintaan-kerohanian", "Permintaan Kerohanian"]
];

const SUKET_FORMS: Array<[string, string, string?]> = [
  ["tab-spri", "Surat Perintah Rawat Inap (SPRI)"],
  ["tab-sk-kematian", "Surat Keterangan Kematian"],
  ["tab-diagnosa", "Surat Keterangan Diagnosa"],
  ["tab-istirahat", "Surat Keterangan Istirahat"],
  ["tab-sehat", "Surat Keterangan Dokter", "surat sehat jasmani keterangan sehat"],
  ["tab-suket-dirawat", "Surat Keterangan Dirawat"],
  ["tab-visum", "Visum et Repertum"],
  ["tab-informed-consent-tindakan", "Informed Consent Tindakan"],
  ["tab-cuti-bersalin", "Surat Keterangan Cuti Bersalin"],
  ["tab-sk-disabilitas", "Surat Keterangan Disabilitas"],
  ["tab-surat-keterangan-kelahiran", "Surat Keterangan Kelahiran (SKL)"],
  ["tab-penanggungjawab-bayi", "Surat Pernyataan Penanggungjawab Bayi"]
];

const RESEP_FORMS: Array<[string, string]> = [
  ["sub-resep-bmhp", "Resep & BMHP"],
  ["sub-lembar-permintaan", "Lembar Permintaan Obat/Paket"],
  ["sub-retur-obat", "Retur Obat"]
];

export const RANAP_FORM_INDEX: FormIndexEntry[] = [
  ...RANAP_RM_FORMS.map((f) => ({
    label: f.label,
    topTab: "tab-rekam-medis",
    group: "Rekam Medis › " + f.category,
    elemId: f.elemId,
    category: f.category
  })),
  ...PERSETUJUAN_FORMS.map(([val, title, keywords]) => ({
    label: title,
    topTab: "tab-persetujuan",
    group: "Persetujuan",
    elemId: val,
    keywords
  })),
  ...SUKET_FORMS.map(([val, title, keywords]) => ({
    label: title,
    topTab: "tab-suket",
    group: "Surat Keterangan",
    elemId: val,
    keywords
  })),
  ...RESEP_FORMS.map(([value, title]) => ({
    label: title,
    topTab: "tab-resep",
    group: "Resep Obat",
    elemId: value
  })),

  {
    label: "Surat Rujukan",
    topTab: "tab-rujukan",
    group: "Rujukan",
    keywords: "rujuk rujukan transfer eksternal dots hiv balik"
  },
  {
    label: "Konsul",
    topTab: "tab-konsul",
    group: "Konsul",
    keywords: "konsultasi konsul jawaban dokter"
  },
  {
    label: "Order Penunjang (Lab / Radiologi)",
    topTab: "tab-penunjang",
    group: "Penunjang",
    elemId: "lab-radiologi",
    keywords: "lab laboratorium radiologi rontgen ro penunjang"
  },
  {
    label: "Penunjang Lain",
    topTab: "tab-penunjang",
    group: "Penunjang",
    elemId: "penunjang-lain",
    keywords: "ekg penunjang"
  },
  {
    label: "Riwayat Hasil Lab (Lintas Kunjungan)",
    topTab: "tab-penunjang",
    group: "Penunjang",
    elemId: "riwayat-hasil-lab",
    keywords: "lab laboratorium riwayat lintas kunjungan penunjang"
  },
  {
    label: "Pengantar Kultur & Tes Kepekaan Antibiotika (Mikrobiologi)",
    topTab: "tab-penunjang",
    group: "Penunjang › Lainnya",
    elemId: "lainnya-kultur-antibiotika",
    keywords: "kultur mikrobiologi antibiotika"
  },
  {
    label: "Formulir Hasil Pemeriksaan USG",
    topTab: "tab-penunjang",
    group: "Penunjang › Lainnya",
    elemId: "lainnya-hasil-usg",
    keywords: "usg"
  },
  {
    label: "Permintaan Pemeriksaan Patologi Anatomi",
    topTab: "tab-penunjang",
    group: "Penunjang › Lainnya",
    elemId: "lainnya-patologi-anatomi",
    keywords: "patologi anatomi pa"
  },
  {
    label: "Dokumentasi Kelainan Kulit",
    topTab: "tab-penunjang",
    group: "Penunjang › Lainnya",
    elemId: "lainnya-kelainan-kulit",
    keywords: "kelainan kulit"
  },
  {
    label: "Permintaan Komponen Darah",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-komponen",
    subTab: "card-permintaan-komponen-darah",
    keywords:
      "transfusi darah utd bdrs bank darah prc wb whole blood trombosit tc prp ffp cryo wrc buffy kolf golongan rhesus komponen"
  },
  {
    label: "Permintaan Komponen Darah Lainnya (Rujukan)",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-komponen-rujukan",
    subTab: "card-komponen-rujukan",
    keywords:
      "rujukan komponen darah luar pmi utd bank darah kirim lainnya"
  },
  {
    label: "Pemeriksaan Golongan Darah Metode Tabung",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-golongan-tabung",
    subTab: "card-golongan-tabung",
    keywords:
      "golongan darah abo rhesus metode tabung cell grouping serum grouping bank darah"
  },
  {
    label: "Pemeriksaan Coomb's Test",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-coombs-test",
    subTab: "card-coombs-test",
    keywords:
      "coombs coomb comb direct indirect dct ict antiglobulin aiha bank darah"
  },
  {
    label: "Pemeriksaan Darah Lainnya (Rujukan)",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-darah-lainnya-rujukan",
    subTab: "card-darah-lainnya-rujukan",
    keywords:
      "rujukan pemeriksaan darah ab dweak wrc leukodepletet bank darah lainnya"
  },
  {
    label: "Permintaan Tindakan Plebotomi Terapi",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-plebotomi-terapi",
    subTab: "card-plebotomi-terapi",
    keywords:
      "plebotomi flebotomi phlebotomy terapi venaseksi polisitemia hemokromatosis bank darah"
  },
  {
    label: "Hasil Pemeriksaan Bank Darah",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-hasil-bank-darah",
    subTab: "card-hasil-bank-darah",
    keywords:
      "hasil bank darah bdrs crossmatch cross match uji cocok serasi mayor minor auto kontrol coombs dct ict kompatibel inkompatibel gel test odak golongan rhesus kantong persetujuan transfusi darah inkompatibel informed consent golongan darah metode tabung cell grouping serum grouping anti a anti b sel a sel b sel o anti d b alb positif negatif pemeriksaan darah lainnya rujukan sab dweak wrc leukodepletet komponen darah lainnya rujukan tempat rujukan plebotomi terapi"
  },
  {
    label: "Pembatalan Komponen Darah",
    topTab: "tab-penunjang",
    group: "Penunjang › Order Darah",
    elemId: "order-darah-pembatalan-komponen",
    subTab: "card-pembatalan-komponen-darah",
    keywords:
      "pembatalan batal kantong darah komponen darah dibatalkan tidak jadi transfusi pasien pulang meninggal bank darah bdrs"
  },
  {
    label: "Input Billing Pelayanan",
    topTab: "tab-billing",
    group: "Billing",
    keywords: "billing tagihan tarif tindakan medik pelayanan"
  },
  {
    label: "Billing Askep",
    topTab: "tab-billing-askep",
    group: "Billing",
    keywords: "billing askep asuhan keperawatan tarif tagihan"
  }
];
